import {
  Container,
  Flex,
  AspectRatio,
  Image
} from '@chakra-ui/react';

import React, { } from "react";
// import core2_foodmarket from '../assets/core2_foodmarket.png'
import core2_foodmarket from '../assets/core2/r37-4grocerREV01-og.png'
// import core2_foodmarket from '../assets/core2/r37-1.png'

export default function Hero() {
  return (
    <FullImgHero />
  );
}

function FullImgHero() {
  return (
    <Container
      maxW={'vh'}
      p={'-4'}
    >
      <Flex
        w={'full'}
        size={'cover'}
        position={'center,center'}>
        <AspectRatio 
        w="full"
        h="100vh"
        position={'relative'}
        >
          <Image
             src={core2_foodmarket}
          />
        </AspectRatio>
      </Flex>
    </Container>
  );
}
